<template>
    <SignupForm v-if="!emailSubmitted" @submitted="onSubmitted"/>
    <SignupConfirmation v-else :registeredEmail="emailSubmitted" />
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import SignupForm from '../components/signup/SignupForm.vue';
import SignupConfirmation from '../components/signup/SignupConfirmation.vue';

@Component({ components: { SignupForm, SignupConfirmation } })
export default class SignupView extends Vue {

    emailSubmitted: string | null = null;

    onSubmitted(email: string): void {
        this.emailSubmitted = email;
    }

}
</script>
